import { urlRegex } from 't2-keystone/utils/isValidUrl';
import { getParsedUrl } from '../../../../utils/getParsedUrl';
import { getLinkTargetByUrl } from '../../../../utils/getLinkTargetByUrl';
import { getLinkRelAttributeValue } from '../../../../utils/getLinkRelAttributeValue';

export const renderCommentContent = (commentContent: string) => {
  const whitespaceRegex = /(\s+)/;
  const chunks = commentContent.split(whitespaceRegex);

  return chunks.map((chunk) => {
    const isUrl = urlRegex.test(chunk.trim());
    if (isUrl) {
      try {
        const { href } = getParsedUrl(chunk);
        const target = getLinkTargetByUrl(href);
        return (
          <a
            className="text-blue-500 hover:underline"
            key={href}
            href={href}
            target={target}
            rel={getLinkRelAttributeValue(href)}
          >
            {href}
          </a>
        );
        // eslint-disable-next-line no-empty
      } catch (error) {}
    }
    return chunk;
  });
};
